import { MenuListItemKey } from 'types/menu-list-items';
import { PartialTranslations } from './default';

export const translationsBundleSe: PartialTranslations = {
    header: {
        copyLink: 'Kopiere liŋkka',
        copiedLinkConfirmed: 'Liŋka lea kopierejuvvon',
    },
    relatedContent: {
        [MenuListItemKey.AppealRights]: 'Váidinvuoigatvuođat',
        [MenuListItemKey.FormAndApplication]: 'Skovit',
        [MenuListItemKey.International]: 'Riikkaidgaskasaš',
        [MenuListItemKey.Membership]: 'Álbmotoaju miellahttovuohta',
        [MenuListItemKey.ProcessTimes]: 'Áššemeannudanáiggit',
        [MenuListItemKey.Rates]: 'Máksomearit',
        [MenuListItemKey.RelatedInformation]: 'Dehálaš dieđutdehálaš dieđut',
        [MenuListItemKey.ReportChanges]: 'Dieđit daid rievdadusaid',
        [MenuListItemKey.RulesAndRegulations]: 'Njuolggadusat',
        [MenuListItemKey.Saksbehandling]: 'Nav áššemeannudanáiggit',
        [MenuListItemKey.Selfservice]: 'Ieš-bálvaleapmi',
        [MenuListItemKey.Shortcuts]: 'Njuolggobálgát',
    },
};
